/**
 * TeleTime POS - Build Stamp (Piece A)
 *
 * Tiny always-visible build id so any deploy can be verified at a glance on a
 * real register — no DevTools. Rendered once from main.jsx, OUTSIDE App's
 * conditional returns, so it shows on every screen (device init, PIN lock,
 * main POS). Injected at build time via the vite `define` in vite.config.js;
 * falls back to 'dev' under the dev server / tests.
 */

/* global __POS_BUILD__ */
export const POS_BUILD_ID = typeof __POS_BUILD__ !== 'undefined' ? __POS_BUILD__ : 'dev';

// Console-checkable too: window.__POS_BUILD
if (typeof window !== 'undefined') {
  window.__POS_BUILD = POS_BUILD_ID;
}

export function BuildStamp() {
  return (
    <div
      data-testid="pos-build-stamp"
      className="fixed bottom-0 right-1 z-[100] font-mono text-[10px] leading-4 text-gray-400/80 pointer-events-none select-none"
    >
      {POS_BUILD_ID}
    </div>
  );
}

export default BuildStamp;
